import React, {useContext, useState} from "react"
import {Button, Card, Col, Divider, Empty, Flex, Grid, Modal, Row, Space, Typography} from "antd"
import {Link, Navigate, Route, Routes, useNavigate, useResolvedPath} from "react-router-dom";
import {SessaoARContext} from "../../../../Contexts/SessaoContext";
import {ParametrosDaSessaoARContext, ParametrosDaSessaoDoResponsavel} from "../../../Sistema/ParametrosDaSessao";
import {EnumTipoUsuario} from "../../../../../Models/Domain/AreaRestrita/Sessao";
import { ListagemDeViagensDoResponsavel } from "../../../../Components/Viagem/Responsavel/ListagemDeViagensDoResponsavel"; import { TypeViagem } from "../../../../../Models/Domain/Viagem/Viagem";
import { EncontrarViagemPelaSenhaParaTipoResponsavel } from "../../../../Components/Viagem/Responsavel/EncontrarViagemPelaSenha";
import { InscricaoDaViagem } from "../../../../Components/Viagem/Responsavel/InscricaoDaViagem";
import { Formatacoes } from "../../../../../Utils/Formatacao";
import { EnumStatusDaInscricaoDoAlunoNaViagem } from "../../../../../Models/Domain/Viagem/Enum";
import { PlusOutlined } from "@ant-design/icons";

export const ViagemParaTipoResponsavel: React.FC<{}> = () => {

    const breakpoint = Grid.useBreakpoint();
    const index = useResolvedPath("").pathname
    const navigate = useNavigate();
    const SessaoAR = useContext(SessaoARContext);
    const sessaoValida = SessaoAR?.sessao?.tipoDeUsuario === EnumTipoUsuario.Responsavel;

    const [viagemSelecionada, setViagemSelecionada] = useState<TypeViagem>();

    const [statusDoModalDeNovaViagem, setStatusDoModalDeNovaViagem] = useState<{exibir: boolean}>({exibir: false});

    if (sessaoValida === false) return <Empty description="A sessão atual da Area Restrita não é uma sessão do tipo responsável" />;

    return <React.Fragment>
        <Card style={{ minHeight: "100%" }}>
            <Routes>
                <Route index key="listagem" element={
                    <React.Fragment>
                        <Modal
                            destroyOnClose
                            open={statusDoModalDeNovaViagem.exibir == true}
                            title={"Senha da viagem"}
                            width={breakpoint.lg ? "80vw" : "90vw"}
                            onCancel={() => {
                                setStatusDoModalDeNovaViagem({ exibir: false });
                            }}
                            footer={(_, { CancelBtn }) => (
                                <Space align="start" style={{ width : "100%" }}>
                                    <CancelBtn />
                                    <Link to={viagemSelecionada?.senha ? "/viagens/inscricao?s=" + viagemSelecionada?.senha : "/"} onClick={() => {
                                        setStatusDoModalDeNovaViagem({ exibir: false });
                                    }}>
                                        <Button type="primary" disabled={viagemSelecionada == undefined}>
                                            Continuar
                                        </Button>
                                    </Link>
                                </Space>
                            )}
                        >
                            <EncontrarViagemPelaSenhaParaTipoResponsavel viagemAPI={[viagemSelecionada, setViagemSelecionada]} />
                        </Modal>

                        <Flex justify="start" gap={8}>
                            <Button
                                type="primary"
                                onClick={() => {
                                    setViagemSelecionada(undefined);
                                    setStatusDoModalDeNovaViagem({ exibir: true })
                                }}
                                icon={<PlusOutlined />}
                            >
                                Nova inscrição
                            </Button>
                            <Typography>
                                <Typography.Title level={4} style={{ margin: 0 }}> Viagens</Typography.Title>
                            </Typography>
                        </Flex>

                        <Divider />

                        <ListagemDeViagensDoResponsavel 
                            obterAcoes={(inscricao) => {
                                const prazoDeInscricao = Formatacoes.paraData(inscricao.viagem?.prazoDeInscricao);
                                const prazoEncerrado = (prazoDeInscricao != undefined && prazoDeInscricao < new Date());

                                const acoes: JSX.Element[] = [];

                                if ((inscricao.viagem?.linkApresentacao?.length ?? 0) > 0)
                                    acoes.push(<Link to={inscricao.viagem!.linkApresentacao!} target="_blank" rel="noopener noreferer">Info. Viagem</Link>);

                                if (inscricao.status == EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO) 
                                    acoes.push(<>N/A</>);
                                // else if (inscricao.status == EnumStatusDaInscricaoDoAlunoNaViagem.INSCRITO_E_PAGO) 
                                //     acoes.push(<Link to={"#"} onClick={() => alert("Não implementado")}> Gerar nota fiscal </Link>);
                                else if (inscricao.status == EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_PAGAMENTO)
                                    acoes.push(<Link to={`/viagens/inscricao?s=${inscricao.viagem?.senha}&a=${inscricao.codAluno}`}>Pagamento</Link>);
                                else if (inscricao.status == EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO) {
                                    if (prazoEncerrado && acoes.length == 0) {
                                        acoes.push(<>N/A</>);
                                    } else {
                                        acoes.push(
                                            <Link to={`/viagens/inscricao?s=${inscricao.viagem?.senha}&a=${inscricao.codAluno}`} >
                                                Pagamento
                                            </Link>
                                        );
                                    }
                                }

                                return acoes;
                            }} 
                        />
                    </React.Fragment>

                } />

                <Route key="inscricao" path="inscricao" element={
                    <InscricaoDaViagem fallback=".."/>
                } />

                <Route path='*' element={<Navigate to={index} />} />
            </Routes>
        </Card>
    </React.Fragment >
}
